import type { FC } from 'react';
import { Collapse } from 'antd';
import type { CollapseProps } from 'antd/lib';

type TabTypes = {
  tabKey: string;
  header: React.ReactNode;
  content: React.ReactNode;
  hidePadding?: boolean;
};

interface CollapsiblePanelProps {
  tabs: TabTypes[];
  activeKey: CollapseProps['activeKey'];
  handleTabClick: (keys: string[]) => void;
  forceRender?: boolean;
  showArrow?: boolean;
}

const CollapsiblePanel: FC<CollapsiblePanelProps> = ({
  tabs = [],
  activeKey = '1',
  handleTabClick = () => {},
  forceRender = false,
  showArrow = true,
}) => {
  const items = tabs.map(({ header, content, hidePadding = false, tabKey }, idx) => ({
    children: content,
    className: hidePadding ? 'padding-none' : '',
    forceRender,
    key: tabKey ? String(tabKey) : String(idx + 1),
    label: header,
    showArrow,
  }));

  return (
    <Collapse
      ghost
      className="common-collapse-container"
      activeKey={activeKey}
      onChange={handleTabClick}
      items={items}
    />
  );
};

export default CollapsiblePanel;
